<template>
  <div>
    <slot></slot>
    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>影片</th>
        <th>說明</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center">
          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="fa fa-trash-alt">  </i></a>
          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>
        </td>
        <td width="300px">
          <input type="text" class="form-control" v-model="item.Url" placeholder="影片網址">
        </td>
        <td >
          <textarea class="form-control" rows="7" v-model="item.Desc"></textarea>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**

 **/

import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";

export default {
  //name: "imageListUpload",
  props: ["datas"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datasDemo:[
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://www.youtube.com/watch?v=sgY7Wx8l6BQ",
          Desc:"內文說明活動說明照片說明1",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://www.youtube.com/watch?v=sgY7Wx8l6BQ",
          Desc:"內文說明活動說明照片說明2",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://www.youtube.com/watch?v=sgY7Wx8l6BQ",
          Desc:"內文說明活動說明照片說明3",
        },
        {
          SystemId:"",
          OrderKey:"",
          Url:"https://www.youtube.com/watch?v=sgY7Wx8l6BQ",
          Desc:"內文說明活動說明照片說明4",
        },
      ]
    };
  },
  methods: {
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas,"SystemId","OrderKey")
    },
    DataItem_AddLast(){
      let newItem=
          {
            SystemId:"",
            OrderKey:"",
            Url:"",
            Desc:"",
          };
      newItem.SystemId =util.uuid();

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.SystemId===item.SystemId);
    },


  },
  mounted() {
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
